/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import ModuleUtils from './ModuleUtils';
import UseSpecType from './UseSpecType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/core/module/util/ModuleUtils (static) // addPlaceHolder, createModule
//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (static) // UseSpecType

/**
 * Utilities for creating and processing a dashboard embedded module
 * @author  mohamedelgemaiey
 */
export default class EmbeddedModuleUtils extends BaseMoserObject{

	/**
	 * Create embedded module
	 * @param {ObjectFactory} objectFactory  : the object factory that will be used to create the module
	 * @param {String} label  : the module label
	 * @param {String} expressionLocale  : the expression locale
	 * @return {Module}
	 */
	static createModule(objectFactory, label, expressionLocale) {
		var embeddedModule = ModuleUtils.createModule(objectFactory, label, expressionLocale);
		embeddedModule.setOverrideMode(true);
		return embeddedModule;
	}

	/**
	 * Add a source to an embedded module
	 * @param {Module} embdeddedModule  : the embedded module
	 * @param {UseSpecType} srcModuleType  : Source type (package, module, file, ...etc)
	 * @param {String} srcModuleStoreId  : source module store id
	 * @param {String} srcModuleSearchPath  : source module search path (Deprecated, ignored)
	 * @param  objectFactory: factory to create module objects
	 * @param  ancestors: the ancestors of the useSpec
	 */
	static addSource(embdeddedModule, srcModuleType, srcModuleStoreId, srcModuleSearchPath, objectFactory, ancestors) {
		var useSpec = objectFactory.createModuleUseSpec();
		useSpec.setIdentifier("ES");
		useSpec.setType(srcModuleType);
		useSpec.setStoreID(srcModuleStoreId);
		useSpec.setImports("*");
		if (ancestors && !(ancestors.length==0)) {
			Array.prototype.push.apply(useSpec.getAncestors(), ancestors);
		}
		embdeddedModule.addUseSpec(useSpec);
		if (UseSpecType.PACKAGE === srcModuleType || UseSpecType.LW_OLAP === srcModuleType || UseSpecType.REPORT === srcModuleType) {
			ModuleUtils._addPlaceHolder(embdeddedModule, useSpec.getIdentifier(), objectFactory);
		}
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/EmbeddedModuleUtils.js